<div class="login-container">
    <div class="login-card">
        <!-- Logo y header -->
        <div class="login-header">
            <div class="logo-wrapper">
                <img src="assets/logos/logo.png" alt="Logo" class="logo" />
            </div>
            <h1 class="welcome-title">Eliminar Cuenta</h1>
            <p class="welcome-subtitle">Solicitud de eliminación de datos personales</p>
        </div>

        <div *ngIf="!isSubmitted" class="login-form">
            <form [formGroup]="deleteForm" (ngSubmit)="onSubmit()">
                <!-- Nombre Completo -->
                <div class="form-field">
                    <label for="fullName" class="field-label">
                        <i class="pi pi-user"></i>
                        Nombre Completo
                    </label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user-edit"></i>
                        </span>
                        <input 
                            type="text" 
                            pInputText
                            id="fullName" 
                            formControlName="fullName"
                            placeholder="Ingresa tu nombre completo"
                            class="form-input"
                            [ngClass]="{'p-invalid': deleteForm.get('fullName')?.touched && deleteForm.get('fullName')?.invalid}"
                        />
                    </div>
                    <small *ngIf="deleteForm.get('fullName')?.touched && deleteForm.get('fullName')?.errors?.['required']" class="p-error">
                        El nombre completo es requerido.
                    </small>
                    <small *ngIf="deleteForm.get('fullName')?.touched && deleteForm.get('fullName')?.errors?.['minlength']" class="p-error">
                        El nombre debe tener al menos 3 caracteres.
                    </small>
                </div>

                <!-- Correo Electrónico -->
                <div class="form-field">
                    <label for="email" class="field-label">
                        <i class="pi pi-envelope"></i>
                        Correo Electrónico
                    </label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-at"></i>
                        </span>
                        <input 
                            type="email" 
                            pInputText
                            id="email" 
                            formControlName="email"
                            placeholder="correo@ejemplo.com"
                            class="form-input"
                            [ngClass]="{'p-invalid': deleteForm.get('email')?.touched && deleteForm.get('email')?.invalid}"
                        />
                    </div>
                    <small *ngIf="deleteForm.get('email')?.touched && deleteForm.get('email')?.errors?.['required']" class="p-error">
                        El correo electrónico es requerido.
                    </small>
                    <small *ngIf="deleteForm.get('email')?.touched && deleteForm.get('email')?.errors?.['email']" class="p-error">
                        Ingresa un formato de correo electrónico válido.
                    </small>
                </div>

                <!-- Razón de la eliminación -->
                <div class="form-field">
                    <label for="reason" class="field-label">
                        <i class="pi pi-question-circle"></i>
                        Motivo de la eliminación (Opcional)
                    </label>
                    <textarea 
                        pInputTextarea
                        id="reason" 
                        formControlName="reason" 
                        rows="4" 
                        placeholder="Cuéntanos brevemente por qué deseas eliminar tu cuenta"
                        class="form-input"
                        [autoResize]="true"
                    ></textarea>
                </div>

                <!-- Casilla de confirmación -->
                <div class="form-options" style="flex-direction: column; align-items: flex-start; gap: 0.5rem; margin-bottom: 2rem;">
                    <div class="remember-me" style="align-items: flex-start;">
                        <p-checkbox 
                            formControlName="confirmCheckbox" 
                            [binary]="true" 
                            inputId="confirmCheckbox"
                        ></p-checkbox>
                        <label for="confirmCheckbox" style="font-size: 0.875rem; line-height: 1.4; color: #495057; margin-left: 0.5rem; cursor: pointer;">
                            Entiendo que esta acción es definitiva. Al procesarse, se eliminará permanentemente mi perfil, historial de accesos y publicaciones asociadas.
                        </label>
                    </div>
                    <small *ngIf="deleteForm.get('confirmCheckbox')?.touched && deleteForm.get('confirmCheckbox')?.invalid" class="p-error">
                        Debes confirmar que aceptas la eliminación permanente de tus datos.
                    </small>
                </div>

                <!-- Botón de Envío -->
                <button 
                    pButton 
                    type="submit" 
                    [disabled]="isSending || deleteForm.invalid" 
                    class="login-button p-button-danger"
                    style="background-color: #ef4444; border-color: #ef4444; width: 100%;"
                >
                    <span *ngIf="!isSending" style="width: 100%; text-align: center;">Enviar Solicitud</span>
                    <span *ngIf="isSending" style="width: 100%; text-align: center;">
                        <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i> Procesando...
                    </span>
                </button>
            </form>
        </div>

        <!-- Mensaje de éxito -->
        <div *ngIf="isSubmitted" class="success-section" style="text-align: center; padding: 2rem 0;">
            <div class="success-icon-container" style="color: #10b981; margin-bottom: 1.5rem;">
                <i class="pi pi-check-circle" style="font-size: 4rem;"></i>
            </div>
            <h2 style="font-size: 1.5rem; font-weight: 700; margin-bottom: 1rem; color: #1f2937;">Solicitud Recibida</h2>
            <p style="font-size: 0.95rem; line-height: 1.6; color: #4b5563; margin-bottom: 1.5rem;">
                Tu solicitud para eliminar la cuenta ha sido registrada en nuestro sistema de manera exitosa.
            </p>
            <p style="font-size: 0.85rem; line-height: 1.5; color: #6b7280; font-style: italic;">
                Capital Humano se pondrá en contacto al correo registrado en un plazo máximo de 24 a 48 horas hábiles para confirmar la baja final de tus datos.
            </p>
        </div>
    </div>
</div>
